import WsProvider from './provider/WSProvider'
var base64 = require('base64_js');
var userDataSidas = localStorage.getItem("userDataSidas") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas")))) : "";
var serviceName = "yonetim";
var crypto = require('crypto');
var yoneticiService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/kucuk/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/enkucuk/",
    girisYap: (kullaniciAdi, sifre) => {
        var param = {
            "data": {
                kullaniciAdi: kullaniciAdi,
                sifre: crypto.createHash('md5').update(sifre).digest("hex"),
                methodName: "login"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sifremiUnuttum(kullaniciAdi,tcNo) {
        var param = {
            data: {
                kullaniciAdi: kullaniciAdi,
                tcNo: tcNo,
                methodName: "sifremiUnuttum"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sifreGuncelle(eskiSifre, yeniSifre) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                yoneticiId: userDataSidas["yonetimId"],
                eskiSifre: crypto.createHash('md5').update(eskiSifre).digest("hex"),
                yeniSifre: crypto.createHash('md5').update(yeniSifre).digest("hex"),
                methodName: "sifremiGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiTanimlama: (firmaKodu, tur, tcNo, image, imageBase, kullaniciAdi, sifre, adSoyad, gorev, eposta, cepTelefon, sabitTelefon, dahili) => {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            "data": {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: firmaKodu,
                tur: tur, // 2: tam yetkili, 3:sınırlı yetki
                tcNo: tcNo,
                image: image,
                imageBase: imageBase,
                kullaniciAdi: kullaniciAdi,
                sifre: crypto.createHash('md5').update(sifre).digest("hex"),
                adSoyad: adSoyad,
                gorev: gorev,
                eposta: eposta,
                cepTelefon: cepTelefon,
                sabitTelefon: sabitTelefon,
                dahili: dahili,
                methodName: "yoneticiTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiList() {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                methodName: "yonetimListesi"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiDetay: (yetkiliKodu) => {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            "data": {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                yetkiliKodu: yetkiliKodu,
                firmaKodu: userDataSidas["firmaKodu"],
                methodName: "yonetimDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiDurumGuncelle(yetkiliKodu, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                yetkiliKodu: yetkiliKodu,
                durum: durum,
                methodName: "yonetimDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiGuncelle: (yonetimKodu,updateList) => {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            "data": {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                yetkiliKodu:yonetimKodu,
                updateList: updateList,
                methodName: "yonetimGuncelle"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yetkiList(){
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            "data": {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                methodName: "yetkiList"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yoneticiYetkiDurum(yetkiliKodu,yetkiKodu,durum){
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            "data": {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                yetkiliKodu: yetkiliKodu,
                yetkiKodu: yetkiKodu,
                durum: durum,
                methodName: "yetkiAtama"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }

};
export default yoneticiService



